import { useRef, useState, useEffect } from "react";
import DateSelect from "./DateSelect";
import { BREAKPOINT } from "../../util";

type DateScopeProps = {
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  setEndDate: React.Dispatch<React.SetStateAction<string>>;
  isScopeVisible: boolean;
  containerWidth: number;
};

function DateScope({
  setStartDate,
  setEndDate,
  isScopeVisible,
  containerWidth,
}: DateScopeProps) {
  const startYearSelectRef = useRef<HTMLDivElement>(null);
  const startMonthSelectRef = useRef<HTMLDivElement>(null);
  const endYearSelectRef = useRef<HTMLDivElement>(null);
  const endMonthSelectRef = useRef<HTMLDivElement>(null);

  const [isStartYearSelectOpen, setIsStartYearSelectOpen] =
    useState<boolean>(false);
  const [isStartMonthSelectOpen, setIsStartMonthSelectOpen] =
    useState<boolean>(false);
  const [isEndYearSelectOpen, setIsEndYearSelectOpen] =
    useState<boolean>(false);
  const [isEndMonthSelectOpen, setIsEndMonthSelectOpen] =
    useState<boolean>(false);

  useEffect(() => {
    document.addEventListener("click", documentOnClick);
    return () => {
      document.removeEventListener("click", documentOnClick);
    };
  }, []);

  // close any open date picker when clicking elsewhere
  function documentOnClick(event: MouseEvent) {
    if (
      startYearSelectRef.current &&
      !startYearSelectRef.current.contains(event.target as Node)
    ) {
      setIsStartYearSelectOpen(false);
    }
    if (
      startMonthSelectRef.current &&
      !startMonthSelectRef.current.contains(event.target as Node)
    ) {
      setIsStartMonthSelectOpen(false);
    }
    if (
      endYearSelectRef.current &&
      !endYearSelectRef.current.contains(event.target as Node)
    ) {
      setIsEndYearSelectOpen(false);
    }
    if (
      endMonthSelectRef.current &&
      !endMonthSelectRef.current.contains(event.target as Node)
    ) {
      setIsEndMonthSelectOpen(false);
    }
  }

  return (
    <div
      className="us-elections-widget__date-scope-select-wrapper"
      style={{ display: isScopeVisible ? "block" : "none" }}
    >
      {containerWidth >= BREAKPOINT && <p>Selected period of time</p>}
      <div className="us-elections-widget__date-scope-select">
        <DateSelect
          yearSelectRef={startYearSelectRef}
          monthSelectRef={startMonthSelectRef}
          name="start-date"
          setDate={setStartDate}
          isYearSelectOpen={isStartYearSelectOpen}
          setIsYearSelectOpen={setIsStartYearSelectOpen}
          isMonthSelectOpen={isStartMonthSelectOpen}
          setIsMonthSelectOpen={setIsStartMonthSelectOpen}
        />
        <DateSelect
          yearSelectRef={endYearSelectRef}
          monthSelectRef={endMonthSelectRef}
          name="end-date"
          setDate={setEndDate}
          isYearSelectOpen={isEndYearSelectOpen}
          setIsYearSelectOpen={setIsEndYearSelectOpen}
          isMonthSelectOpen={isEndMonthSelectOpen}
          setIsMonthSelectOpen={setIsEndMonthSelectOpen}
        />
      </div>
    </div>
  );
}

export default DateScope;
